const namespace = 'connections/payex/callback';
export default namespace;
